
export default {
    data () {
        return { file: null, report: null, mapping: {}, result: null, busy: false }
    },
    computed: {
        advisorOptions () {
            const advisors = (this.report && this.report.advisors) || []
            return [{ value: null, text: 'Unattributed' }, ...advisors.map(a => ({ value: a.id, text: a.name }))]
        },
    },
    watch: {
        file () {
            this.report = null
            this.result = null
            this.mapping = {}
        },
    },
    methods: {
        formWith (extra = {}) {
            const form = new FormData()
            form.append('file', this.file)
            Object.entries(extra).forEach(([key, value]) => form.append(key, value))
            return form
        },
        async check () {
            if (!this.file || this.busy) return
            this.busy = true
            const res = await this.$try('checkJotformImport', this.formWith())
            this.busy = false
            if (!res || res.error) return
            this.report = res
            this.mapping = Object.fromEntries(res.names.map(n => [n.key, n.proposed_agent_id]))
            this.result = null
        },
        async runImport () {
            if (!this.file || this.busy) return
            this.busy = true
            const res = await this.$try('importJotformFeedback', this.formWith({ mapping: JSON.stringify(this.mapping) }))
            this.busy = false
            if (!res || res.error) return
            this.result = res
            this.$emit('imported', res)
        },
    },
}
